import { hasOverride } from '../communication-catalog/catalogModel';
import type { ObjectArea } from './objectAreas';
import type { AreaStatusInput } from './objectAreaStatus';

export interface OverviewFact {
  id: 'apartments' | 'vertrieb' | 'zeiten' | 'nachrichten';
  label: string;
  value: string;
  unit?: string;
  detail: string;
}

const time = (value: string) => value.slice(0, 5);

/** Wenige stabile Kennzahlen; was der Nutzer nicht lesen darf, fehlt ganz statt als Lücke. */
export function overviewFacts(input: AreaStatusInput, areas: ObjectArea[]): OverviewFact[] {
  const visible = new Set(areas.map((area) => area.id));
  const { group } = input;
  const total = group.apartments.length;
  const active = group.apartments.filter((apartment) => apartment.status === 'Active').length;
  const facts: OverviewFact[] = [
    {
      id: 'apartments',
      label: 'Apartments',
      value: String(total),
      detail: total === 0 ? 'noch keine' : active === total ? 'alle aktiv' : `${active} aktiv`,
    },
  ];
  const units = input.publication?.units ?? [];
  if (visible.has('veroeffentlichung') && units.length > 0) {
    const published = units.filter((unit) => unit.state === 'Published').length;
    facts.push({
      id: 'vertrieb',
      label: 'Vertrieb',
      value: String(published),
      unit: `von ${units.length}`,
      detail: 'beim Kanalmanager veröffentlicht',
    });
  }
  facts.push({
    id: 'zeiten',
    // Geschützte Bindestriche: schmal bricht die Zeile hinter dem Punkt, nicht in „Check-out".
    label: 'Check‑in · Check‑out',
    value: `${time(group.checkInTime)} · ${time(group.checkOutTime)}`,
    detail: 'gilt für alle Apartments',
  });
  if (visible.has('nachrichten') && input.catalog) {
    const messages = input.catalog.messages;
    const customized = messages.filter((message) => message.channels.some(hasOverride)).length;
    facts.push({
      id: 'nachrichten',
      label: 'Nachrichten',
      value: String(messages.filter((message) => message.isEnabled).length),
      unit: `von ${messages.length} aktiv`,
      detail: customized > 0 ? `${customized} angepasst` : 'alle im StayOn-Standard',
    });
  }
  return facts;
}
